import { createObjectCRUDSlice } from './generators/objectCRUD.store'

const slice = createObjectCRUDSlice('userDetail')

export const {
    userDetailGetObjectAction,
    userDetailSetObjectAction,
    userDetailUpdateObjectAction,
    userDetailAddObjectAction,
    userDetailDeleteObjectAction,
    userDetailObjectErrorAction,
    userDetailObjectResetStateAction,
} = slice.actions

export default slice.reducer
